import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { Button, Alert } from 'react-bootstrap';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormRichEditor from 'components/forms/FormRichEditor';
import CommentCard from 'components/layout/CommentCard';

class LeadComments extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      showCommentForm: false,
      showAllComments: false, // if false, only last 3 will be shown
      value: '', // value in new comment form
      validation: { valid: true },
    };
  }

  doShowAll = () => {
    this.setState({ showAll: true });
  };

  showAllComments = e => {
    e.preventDefault();
    this.setState({ showAllComments: true });
  };

  formSubmit = e => {
    e.preventDefault();

    if (this.state.value !== '') {
      this.setState({ validation: { valid: true } });
      this.props.onSubmit(this.props.entity.getId(), { content: this.state.value });
    } else {
      this.setState({
        validation: { valid: false, helpText: this.props.intl.messages['This value should not be blank'] },
      });
    }
  };

  renderComments = () => {
    const {
      intl: { messages },
      entity,
    } = this.props;

    if (entity.getComments() && entity.getComments().length) {
      const result = [];
      const comments = entity.getComments();
      for (let i = 0; i < comments.length; i++) {
        if (i < 3 || this.state.showAllComments) {
          result.push(<CommentCard key={i} comment={comments[i]} timezone={this.props.user.profile.timezone} />);
        } else if (i === 3 && !this.state.showAllComments) {
          result.push(
            <div key="show-more" class="text-center m-t-10 m-b-20">
              <a href="#showAll" onClick={this.showAllComments}>
                {messages.show_all_comments}
              </a>
            </div>
          );
        }
      }

      return result;
    }

    return <Alert bsStyle="info">{this.props.intl.messages.no_comments_yet}</Alert>;
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      doNotify,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      doNotify(1, messages.comment_saved);
      this.refs.commentEditor.setValue('');
    }
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      formStatus,
    } = this.props;

    return (
      <div class="clearfix">
        {entityLoaded && (
          <>
            <h3>{messages.comments}</h3>
            {this.renderComments()}

            <div class="panel">
              <div class="panel-body">
                {this.state.showCommentForm ? (
                  <form method="post" onSubmit={this.formSubmit}>
                    <p className="form-group-title">{messages.comment}</p>
                    <div class="form-group-attached">
                      <FormRichEditor
                        ref="commentEditor"
                        name="newComment"
                        title={messages.comment}
                        value={this.state.value}
                        onChange={(fieldName, value) => this.setState({ value })}
                        validation={this.state.validation}
                        disabled={formStatus.pending}
                        initAtWho
                      />
                    </div>
                    <div class="text-right m-t-15">
                      <Button
                        disabled={formStatus.pending}
                        type="submit"
                        bsStyle={this.state.value !== '' ? 'primary' : 'default'}
                      >
                        <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                        {messages.save}
                      </Button>
                    </div>
                  </form>
                ) : (
                  <Button onClick={() => this.setState({ showCommentForm: true })}>
                    <i class="far fa-comment" /> {messages.comment}
                  </Button>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.leadCommentNew,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    onSubmit: (leadId, args) => {
      formStatusDispatchHelper('leadCommentNew', '/api/leads/' + leadId + '/comments.json', args, 'post', dispatch);
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LeadComments)
);
